module.exports = __webpack_public_path__ + "img/agent.59fc357c.svg";